import { IndicadoresVariaveisAmbiente, IndicadoresVariaveisAmbienteEdicao } from '@containers';
import { InfoUsuario } from '@utils';

const getPermissaoFila = (infoUsuario) => InfoUsuario.perm('admin') || InfoUsuario.perm('fila');

export default [
  {
    path: '/indicadores/variaveis/ambiente',
    parent: '/indicadores',
    text: 'Variáveis de Ambiente',
    match: /\/indicadores\/variaveis\/ambiente+$/,
    sider: true,
    component: IndicadoresVariaveisAmbiente,
    exact: true,
    secret: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
  {
    path: '/indicadores/variaveis/ambiente/:idCliente/:idInformacao',
    text: 'Variável de Ambiente',
    component: IndicadoresVariaveisAmbienteEdicao,
    secret: true,
    exact: true,
    permissions: (infoUsuario) => getPermissaoFila(infoUsuario),
  },
];
